import { match } from 'ts-pattern';
import type { ThemeMode } from '../types';

/**
 * Convert a theme mode to a MUI palette mode.
 * @param mode A theme mode.
 * @returns A MUI palette mode.
 */
export function convertToMuiThemeMode(mode: ThemeMode): 'dark' | 'light' {
  return match(mode)
    .with('twilight', () => 'dark' as const)
    .with('dark', () => 'dark' as const)
    .with('light', () => 'light' as const)
    .exhaustive();
}
